import React, { Component } from 'react';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import withStyles from '@material-ui/core/styles/withStyles';
import PropTypes from 'prop-types';
import Buttoncontrol from "../GeneralUI/Buttoncontrol";
import Textfieldlabel from "../GeneralUI/Textfieldlabel";
import Grid from '@material-ui/core/Grid';
import InputLabel from '@material-ui/core/InputLabel';
import Button from '@material-ui/core/Button';
import PSelect from '../GeneralUI/PSelect'
import { SnackbarProvider, withSnackbar } from 'notistack';
import Tooltip from '@material-ui/core/Tooltip';
import Chip from '@material-ui/core/Chip';
import Visibility from '@material-ui/icons/Visibility';
import { getDocument } from '../../Actions/General';

import { withRouter } from 'react-router';
import Styles from '../GeneralUI/Styles';
import Utils from '../../Libs/utils';


class Empresa extends Component {

  state = {
    fields: {
      empresaCodigo: null,
      empresaRazonSocial: null,
      empresaNit: null,
      empresaDigitoVerificacion: null,

      empresaRegimen: null,
      empresaDireccion: null,
      empresaTelefono: null,

      empresaCelular: null,
      empresaCorreoElectronico: null,
      empresaResponsable: null,

      monedaCodigo: null,
      createdAt: Utils.fullDateTime(),
      updatedAt: Utils.fullDateTime()
    },
    responseForm: { Message: '', typeMessage: '' }
  };

  componentDidMount() {
    const params = this.props.match.params;

    if (!params.id) {
      return;
    }

    getDocument({
      documentId: params.id,
      fieldName: 'empresaCodigo',
      moduleName: params.module
    }).then(document => {
      if (!document) {
        return;
      }
      console.log("documents:", document);
      this.setState({ fields: document });
    });

  }

  handleSeguir = () => {
    alert('Seguimiento registrado.');
  }

  handleChange = (event) => {
    let { fields } = this.state;
    if (event.target.type === 'time') {
      fields[event.target.id] = event.target.value;
    } else if (event.target.type === 'number') {
      fields[event.target.id] = event.target.value;
    } else {
      fields[event.target.id] = event.target.value.toUpperCase();
    }
    this.setState({ fields });
  }

  save = (response) => {
  this.setState({
    fields: response.data,
    responseForm: response.responseForm
  });
    this.props.enqueueSnackbar(
      response.responseForm.Message,
      { variant: response.responseForm.typeMessage }
    );
  }

  render() {
    return (
      <Paper elevation={5} className={this.props.classes.mainPaper}>

        <form className={this.props.form} onSubmit={e => e.preventDefault()}>
          <Grid container spacing={3} className={this.props.classes.gridForm}>
            <InputLabel id="empresaCodigo" className={this.props.classes.tittleLabelForm}>
              Empresa
            </InputLabel>
            <Grid item xs={6} className={this.props.classes.chipTitle}>
              {(this.state.fields.empresaCodigo !== null) ?
                (<Chip
                  label={this.state.fields["empresaCodigo"]}
                  clickable
                  color="primary"
                  onDelete={this.handleSeguir}
                  deleteIcon={<Tooltip title="Seguir" placement="right-start"><Visibility /></Tooltip>}
                />) : ''
              }
            </Grid>
          </Grid>

          <Grid container spacing={4}>
            <Grid item xs={3} className={this.props.classes.gridForm}>
              <TextField id="empresaRazonSocial" label="Razon Social (*)" type="text"

                fullWidth margin="normal" variant="outlined"
                onChange={this.handleChange}
                value={this.state.fields["empresaRazonSocial"]}
              />
            </Grid>


            <Grid item xs={3} className={this.props.classes.gridForm}>
              <TextField id="empresaNit" label="Nit (*)" type="text"

                fullWidth margin="normal" variant="outlined"
                onChange={this.handleChange}
                value={this.state.fields["empresaNit"]}
              />
            </Grid>
            <Grid item xs={3} className={this.props.classes.gridForm}>
              <PSelect
                id="empresaDigitoVerificacion"
                useChildren={true}
                value={this.state.fields["empresaDigitoVerificacion"]}
                onChange={this.handleChange}
                namelabel="Digito Verificacion (*)"
              >
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
                <option value="6">6</option>
                <option value="7">7</option>
                <option value="8">8</option>
                <option value="9">9</option>
              </PSelect>
            </Grid>
          </Grid>

          <Grid container spacing={4}>
            <Grid item xs={3} className={this.props.classes.gridForm}>
              <PSelect
                id="empresaRegimen"
                useChildren={true}
                value={this.state.fields["empresaRegimen"]}
                onChange={this.handleChange}
                namelabel="Tipo Regimen (*)"
              >
                <option value="COMUN">COMUN</option>
                <option value="SIMPLIFICADO">SIMPLIFICADO</option>
              </PSelect>

            </Grid>
            <Grid item xs={3} className={this.props.classes.gridForm}>
              <TextField id="empresaDireccion" label="Direccion (*)" type="text"

                fullWidth margin="normal" variant="outlined"
                onChange={this.handleChange}
                value={this.state.fields["empresaDireccion"]}
              />
            </Grid>
            <Grid item xs={3} className={this.props.classes.gridForm}>
              <TextField id="empresaTelefono" label="Telefono (*)" type="text"

                fullWidth margin="normal" variant="outlined"
                onChange={this.handleChange}
                value={this.state.fields["empresaTelefono"]}
              />
            </Grid>
          </Grid>

          <Grid container spacing={4}>
            <Grid item xs={3} className={this.props.classes.gridForm}>
              <TextField id="empresaCelular" label="Celular (*)" type="text"

                fullWidth margin="normal" variant="outlined"
                onChange={this.handleChange}
                value={this.state.fields["empresaCelular"]}
              />
            </Grid>
            <Grid item xs={3} className={this.props.classes.gridForm}>
              <TextField id="empresaCorreoElectronico" label="Correo Electronico (*)" type="text"

                fullWidth margin="normal" variant="outlined"
                onChange={this.handleChange}
                value={this.state.fields["empresaCorreoElectronico"]}
              />
            </Grid>
            <Grid item xs={3} className={this.props.classes.gridForm}>
              <TextField id="empresaResponsable" label="Responsable (*)" type="text"

                fullWidth margin="normal" variant="outlined"
                onChange={this.handleChange}
                value={this.state.fields["empresaResponsable"]}
              />
            </Grid>
          </Grid>

          <Grid container spacing={4}>
            <Grid item xs={3} className={this.props.classes.gridForm}>
              <PSelect
                namelabel="Moneda (*)"
                id="monedaCodigo"
                namelineInput="moneda"
                fieldVisible="monedaNombre"
                fieldCode="monedaCodigo"
                Table="Moneda"
                Vista="true"
                Where="true"
                useChildren={false}
                onChange={this.handleChange}
                value={this.state.fields["monedaCodigo"]}
              />
            </Grid>
          </Grid>


          <Grid container spacing={10} >
            <Grid item xs={3} className={this.props.classes.gridForm}>
              <Textfieldlabel label="Usuario" value={Utils.getFromLocalStorage('userInfo').usuarioNombreCompleto} />
            </Grid>
            <Grid item xs={3} className={this.props.classes.gridForm}>
              <Textfieldlabel label="Fecha Creacion" value={this.state.fields.createdAt} />
            </Grid>
            <Grid item xs={3} className={this.props.classes.gridForm}>
              <Textfieldlabel label="Fecha Modificacion" value={this.state.fields.updatedAt} />
            </Grid>
          </Grid>


        </form>
        <div><Buttoncontrol

          saveData={this.state.fields}
          moduleName={this.props.match.params.module}
          save={this.save}
          primaryFields={['empresaCodigo']}

        /></div>
      </Paper>
    );
  }
}

Empresa.propTypes = {
  onClick: PropTypes.func.isRequired,
  enqueueSnackbar: PropTypes.func.isRequired,
};

const MyApp = withRouter(withSnackbar(withStyles(Styles, { withTheme: true })(Empresa)));

function IntegrationNotistack() {
  return (
    <SnackbarProvider maxSnack={1}
      action={[
        <Button variant="text" color="primary" size="small">
          {'X'}
        </Button>
      ]}

    >
      <MyApp />
    </SnackbarProvider>
  );
}


export default IntegrationNotistack;